import {Component, NgZone, OnInit, ViewChild} from '@angular/core';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { itLocale } from 'ngx-bootstrap/locale';
defineLocale('it', itLocale);
import {SnackBarHandlerService} from './commons/snack-bar-handler.service';
import {AuthService} from './auth-n-routing/auth-service.service';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import {BusyServices} from './commons/busy.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
	@ViewChild('snackbar', { static: true } ) snackbar;

	constructor(public snackBarHandler: SnackBarHandlerService,
				public ngZone: NgZone, public busy: BusyServices,
				public authService: AuthService,
				private localeService: BsLocaleService) {

	}

	ngOnInit() {
		this.localeService.use('it');
		this.snackBarHandler.setSnackbar(this.snackbar);
		// window.addEventListener('scroll', this.scroll, true); //third parameter
	}
}
